import { useContext } from 'react';
import RichTextContext from '../context';
import TextDefault from './TextDefault';

export const JudgeChecker = (attr) => +attr?.position_judge === 1 || [1, 3].includes(+attr?.judge);

export default function Judge(props) {
  const { children, ...rest } = props;
  const _isPositionJudge = +props?.position_judge === 1;
  const richTextContex = useContext(RichTextContext);

  // 根据文本行高度自适应尺寸
  const size = richTextContex.lineHeight * 0.5;

  return (
    <TextDefault {...rest}>
      {children}
      &nbsp;
      <img
        src={
          _isPositionJudge
            ? 'https://i9.taou.com/maimai/p/28546/3784_6_U1aKvdGIdpgfTe'
            : 'https://i9.taou.com/maimai/p/26356/8977_53_h2RhylRzun3MJr'
        }
        style={{
          display: 'inline-block',
          width: size,
          height: size,
        }}
      />
    </TextDefault>
  );
}
